import processSpecificSkillChange from '../processes/processSpecificSkillChange'
import processSkillAdjs from '../processes/processSkillAdjs'

import createNewCharacterSkillEntry from '../helpers/createNewCharacterSkillEntry'
//----------------------------------------------------------------
// process add skill e.g. specialism, lore, language, runecasting
//----------------------------------------------------------------
export default function processAddSkill({
  parms = {},
  changed_skills = [],
  original_skills = [],
  static_skill = null,
  character = null,
}) {
  console.log('------------------------')
  console.log('IN processAddSkill parms = ', parms)
  console.log(
    '1. character skill_adjs in processAddSkill = ',
    window.$deepCopy(character.skill_adjs),
  )
  console.log('1b. character skills in processAddSkill = ', window.$deepCopy(character.skills))
  //-----------
  // get parms
  //-----------
  const new_temp_id = parms.payload.id ? parms.payload.id : null // for tracking/local only
  const ticks = parms.payload.ticks ? parms.payload.ticks : 0
  const training = parms.payload.training ? parms.payload.training : 0
  const display_name = parms.payload.display_name ? parms.payload.display_name : null // optional for runecasting (rune name)
  //----------------------------------
  // create new character skill entry
  //----------------------------------
  console.log('2. off to create new character skill entry')
  let new_skill = createNewCharacterSkillEntry({
    id: new_temp_id,
    static_skill: static_skill,
    ticks: ticks,
    training: training,
    display_name: display_name,
    character: character.id ? character.id : null,
  })
  //-------------------------------
  // add skill to character skills
  //-------------------------------
  character.skills.push(new_skill)
  console.log('4. NEW SKILL ADDED TO CHARACTER = ', window.$deepCopy(new_skill))
  console.log('5. character.skills = ', window.$deepCopy(character.skills))
  //----------------------------------------------------
  // go manage skill changes (do calcs / track changes)
  //----------------------------------------------------
  console.log(
    '3b. character skill_adjs BEFORE processSpecificSkillChange = ',
    window.$deepCopy(character.skill_adjs),
  )
  console.log('3c. skills BEFORE processSpecificSkillChange = ', window.$deepCopy(character.skills))
  changed_skills = processSpecificSkillChange({
    skill: new_skill,
    original_skills: original_skills,
    changed_skills: changed_skills,
    character: character,
  })
  //--------------------------------------------------------------------------
  // process new local skill adjs (collect adjs + load skills for this skill)
  //--------------------------------------------------------------------------
  console.log('4. off to process new local skill for existing character')
  console.log('5. skill adjs BEFORE processSkillAdjs = ', window.$deepCopy(character.skill_adjs))
  console.log('5b. skills BEFORE processSkillAdjs = ', window.$deepCopy(character.skills))
  const res = processSkillAdjs({ skill: new_skill, character })
  //---------------
  // load response
  //---------------
  if (res) {
    new_skill = res.skill
    character = res.character
  } else {
    console.error('Error processing skill adjs for new skill = ' + new_skill.name)
  }
  console.log('6. skill adjs = ', window.$deepCopy(character.skill_adjs))
  console.log('6b. skills = ', window.$deepCopy(character.skills))
  console.log('6c. new skills = ', window.$deepCopy(new_skill))
  console.log('END processAddSkill')
  //------------------------
  // return mutated objects
  //------------------------
  return { changed_skills, new_skill, apply_adj_all_skills: static_skill.all_in_type, character }
}
